/* homepage-essays.js — click-and-drag scroll + eager preload for .mgm-mag-grid */
(function () {
  var grids = document.querySelectorAll('.mgm-mag-grid');
  if (!grids.length) return;

  /* PRELOAD: force all images in every carousel to load immediately by
     stripping `loading="lazy"`. The cards are below the fold but only ~80KB
     each, so total payload stays small. This eliminates the swipe flicker. */
  grids.forEach(function (grid) {
    var imgs = grid.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
        /* If the image hasn't started fetching yet, force it by re-assigning
           src. Browsers re-evaluate the src on assignment, triggering fetch. */
        if (!img.complete) {
          var src = img.src;
          img.src = '';
          img.src = src;
        }
      }
      img.setAttribute('fetchpriority', 'high');
      img.setAttribute('decoding', 'async');
    });
  });

  /* DRAG-TO-SCROLL — Windows mouse users who can't natively swipe.
     Magic Mouse, touch screens, and trackpads use native scroll on top. */
  var hasFinePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!hasFinePointer) return;

  /* Rewritten 2026-09-03 with pointer capture, fixing two desktop defects Hari
     reported as "hold and slide is not working perfectly":
     1. The browser's native link/image ghost-drag started on mousedown+move and
        swallowed the custom drag (fixed here via dragstart preventDefault, and
        in CSS via user-drag:none on the cards).
     2. Listeners lived on the grid only, so the drag died the moment the cursor
        left the row mid-slide. setPointerCapture keeps the stream alive wherever
        the pointer goes until release. */
  grids.forEach(function (grid) {
    var isDown = false;
    var hasDragged = false;
    var startX = 0;
    var startScroll = 0;
    var DRAG_THRESHOLD = 6;

    grid.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    grid.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      isDown = true;
      hasDragged = false;
      startX = e.pageX;
      startScroll = grid.scrollLeft;
    });

    /* 2026-09-18: capture moved from pointerdown to the moment a drag starts.
       Capturing on pointerdown retargeted every click to the grid, so the
       journal card links stopped opening on desktop (Hari reported it). A plain
       click is never captured now; a real drag still keeps its capture. */
    grid.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.pageX - startX;
      if (!hasDragged && Math.abs(delta) > DRAG_THRESHOLD) {
        hasDragged = true;
        grid.classList.add('mgm-mag-grid--dragging');
        grid.setPointerCapture(e.pointerId);
      }
      if (hasDragged) {
        e.preventDefault();
        grid.scrollLeft = startScroll - delta;
      }
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      grid.classList.remove('mgm-mag-grid--dragging');
      if (grid.hasPointerCapture && grid.hasPointerCapture(e.pointerId)) {
        grid.releasePointerCapture(e.pointerId);
      }
    }
    grid.addEventListener('pointerup', endDrag);
    grid.addEventListener('pointercancel', endDrag);

    grid.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);
  });
})();
